function exception (exception) {
    this.codigo = exception.codigo;
    this.mensaje = exception.mensaje;
}

export default exception;